<div class="data-area">
    <table class="table table-hover table-inline-edit">
        <thead class="thead-light">
            <tr>
                <!-- <th width="60%">Species</th>
                <th class="sorting">
                    Planting Area #</th>
                <th>Name</th>
                <th class="">Color</th>
                <th>Year</th>
                <th>KML</th>
                <th>Flight path</th>
                <th></th> -->
                <th class="sorting"
                    [class.acs]="sortColumn === col && sortAsc"
                    [class.dcs]="sortColumn === col && !sortAsc"
                    [class.text-right]="col.textRight"
                    *ngFor="let col of columns"
                    (click)="sortBy(col)">
                    {{col.title}}
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr areasRow *ngFor="let area of plantingSiteAreas"
                [currentUser]="currentUser"
                [isEditPlantedTree]="true"
                [plantingSiteId]="plantingSiteId"
                [areaInput]="area"
                (onDelete)="delete($event)">
            </tr> -->
            <tr *ngFor="let areaInput of plantingSiteAreas">
                <td>{{areaInput.code}}</td>
                <td>{{areaInput.name}}</td>
                <td>
                    <div class="row">
                        <div *ngFor="let areaProperties of areaInput.kmlAreaProperties" class="col-sm-2">
                            <div class="area-color"
                                [style.border-color]="areaProperties.lineColor ? areaProperties.lineColor : areaProperties.bodyColor"
                                [style.background]="areaProperties.bodyColor"></div>
                        </div>
                    </div>
                </td>
                <td>{{areaInput.year}}</td>
                <td>{{areaInput.kmlUrl ? 'Yes' : 'No'}}</td>
                <td>{{areaInput.flightPathUrl ? 'Yes' : 'No'}}</td>
                <td class="table-button">
                    <a class="edit" title="Videos"
                        [routerLink]="['/admin', 'plantingSites', plantingSiteId, 'plantings', areaInput.id, 'videos']">
                        <i class="icon-camrecorder"></i></a>
                    <a class="edit" title="Images"
                        [routerLink]="['/admin', 'plantingSites', plantingSiteId, 'plantings', areaInput.id, 'images']">
                        <i class="icon-picture"></i></a>
                    <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="edit" title="Trees"
                        [routerLink]="['/admin', 'plantingSites', plantingSiteId, 'plantings', areaInput.id, 'trees']">
                        <i class="icon-tree"><img src="/assets/icon/tree.svg" /></i></a>
                    <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="edit" title="Edit"
                        [routerLink]="['/admin', 'plantingSites', plantingSiteId, 'plantings', areaInput.id]">
                        <i class="icon-note"></i></a>
                    <a *ngIf="currentUser?.permissions.canManageUsers" class="delete" title="Delete"
                        (click)="delete(areaInput)">
                        <i class="icon-trash"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>
